import { TravelRequestFilterState } from "./travel-request-filter-state";
import { TravelRequestFilter } from "../hooks/use-travel-request-search-filters";
import { isEmpty } from "lodash";

export function mapFiltersToTravelRequestQueryInput(
  data: Partial<TravelRequestFilterState>
): TravelRequestFilter {
  const result: TravelRequestFilter = {};
  if (!isEmpty(data.text)) {
    result.text = data.text;
  }

  if (!isEmpty(data.responsiblePerson)) {
    result.responsibleUserIds = data.responsiblePerson;
  }

  if (!isEmpty(data.senderIds)) {
    result.senderIds = data.senderIds;
  }

  if (!isEmpty(data.travelRequestStatusFilter)) {
    result.status = data.travelRequestStatusFilter;
  }

  if (data.createdFromTo?.from) {
    result.from = data.createdFromTo.from || null;
  }

  if (data.createdFromTo?.to) {
    result.to = data.createdFromTo.to || null;
  }

  return result;
}
